import { render, staticRenderFns } from "./inactive-accounts.page.vue?vue&type=template&id=a03fb06c&"
import script from "./inactive-accounts.page.vue?vue&type=script&lang=ts&"
export * from "./inactive-accounts.page.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports